module.exports = __webpack_public_path__ + "asset/agm-agenda-pdf--4995d4.png";